import React, { useState, useEffect } from 'react';
import { cloneDeep } from 'lodash';
import Plus from '../../../images/icons/plus.svg';
import SearchBar from '../../ui/search/search-bar';
import { titleCase } from '../../base/common/utils';
import AccountService from './account-service';

const NetworkLists = ({
  otherOrgType,
  inNetworkOrgs,
  outOfNetworkOrgs,
  setInNetworkOrgs,
  setOutOfNetworkOrgs,
}) => {
  const [inNetworkResults, setInNetworkResults] = useState(inNetworkOrgs);
  const [outOfNetworkResults, setOutOfNetworkResults] = useState(outOfNetworkOrgs);
  const [inNetworkSearchTerm, setInNetworkSearchTerm] = useState('');
  const [outOfNetworkSearchTerm, setOutOfNetworkSearchTerm] = useState('');

  useEffect(() => {
    setInNetworkResults(filterByName(inNetworkOrgs, inNetworkSearchTerm));
    setOutOfNetworkResults(filterByName(outOfNetworkOrgs, outOfNetworkSearchTerm));
  }, [inNetworkSearchTerm, outOfNetworkSearchTerm, inNetworkOrgs, outOfNetworkOrgs]);

  function filterByName(orgs, searchTerm) {
    let newOrgs = cloneDeep(orgs);
    newOrgs = orgs.filter(result =>
      result.short_name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return newOrgs;
  }

  function changeOrgNetworkStatus(currentStatus, name) {
    const newInNetworkOrgs = cloneDeep(inNetworkOrgs);
    const newOutOfNetworkOrgs = cloneDeep(outOfNetworkOrgs);
    const listToRemoveFrom = currentStatus === 'in' ? newInNetworkOrgs : newOutOfNetworkOrgs;
    const listToAddTo = currentStatus === 'in' ? newOutOfNetworkOrgs : newInNetworkOrgs;

    const index = listToRemoveFrom.findIndex(org => org.short_name === name);
    const org = listToRemoveFrom.splice(index, 1)[0];
    listToAddTo.push(org);

    setInNetworkOrgs(AccountService.sortByName(newInNetworkOrgs));
    setOutOfNetworkOrgs(AccountService.sortByName(newOutOfNetworkOrgs));
  }

  function changeAll(inNetwork) {
    const listToAdd = inNetwork ? outOfNetworkResults : inNetworkResults;

    const listToAddTo = inNetwork ? inNetworkOrgs : outOfNetworkOrgs;
    const setListToAddTo = inNetwork ? setInNetworkOrgs : setOutOfNetworkOrgs;

    const listToRemoveFrom = inNetwork ? outOfNetworkOrgs : inNetworkOrgs;
    const setListToRemoveFrom = inNetwork ? setOutOfNetworkOrgs : setInNetworkOrgs;

    setListToAddTo(AccountService.sortByName(listToAddTo.concat(listToAdd)));
    const filteredOrgs = listToRemoveFrom.filter(org => !listToAdd.includes(org));
    setListToRemoveFrom(AccountService.sortByName(filteredOrgs));
  }

  function getNetworkList(inNetwork) {
    let list;
    if (inNetwork) {
      list = inNetworkResults.length ? (
        inNetworkResults.map((org, index) => (
          <div
            className="network-org"
            onClick={() => changeOrgNetworkStatus('in', org.short_name)}
            key={index}
          >
            {org.short_name}
            <span className="icon-container subtract">
              <span className="subtract-icon"></span>
            </span>
          </div>
        ))
      ) : (
        <div className="no-results">No in-network {otherOrgType}s</div>
      );
    } else {
      list = outOfNetworkResults.length ? (
        outOfNetworkResults.map((org, index) => (
          <div
            className="network-org"
            onClick={() => changeOrgNetworkStatus('out', org.short_name)}
            key={index}
          >
            {org.short_name}
            <span className="icon-container plus">
              <img src={Plus} alt="plus" className="plus-icon" />
            </span>
          </div>
        ))
      ) : (
        <div className="no-results">No out-of-network {otherOrgType}s</div>
      );
    }
    return list;
  }

  return (
    <div className="form network-lists">
      <div className="in-network">
        <div className="subtitle">In-Network {otherOrgType}s</div>
        <div className="menu">
          <SearchBar
            onChange={setInNetworkSearchTerm}
            placeholder={`Search for a ${titleCase(otherOrgType)}`}
          />
          <button className="change-all" onClick={() => changeAll(false)}>
            Remove All ({inNetworkResults.length})
          </button>
          <div className="network-list">{getNetworkList(true)}</div>
        </div>
      </div>
      <div className="out-of-network">
        <div className="subtitle">Out-of-Network {otherOrgType}s</div>
        <div className="menu">
          <SearchBar
            onChange={setOutOfNetworkSearchTerm}
            placeholder={`Search for a ${titleCase(otherOrgType)}`}
          />
          <button className="change-all" onClick={() => changeAll(true)}>
            Add All ({outOfNetworkResults.length})
          </button>
          <div className="network-list">{getNetworkList(false)}</div>
        </div>
      </div>
    </div>
  );
};

export default NetworkLists;
